/* eslint-disable jsx-a11y/label-has-for */
import React from "react"
import { Field } from "redux-form"
import { Flex } from "src/components/Grid"
import { Caption } from "@infotech/uikit-text"

export default props => {
  const { htmlId, label, name, InputComponent, elementType } = props

  return (
    <Flex column style={{ marginBottom: 8 }}>
      <label htmlFor={htmlId}>
        <Caption.Blocky>{label}</Caption.Blocky>
      </label>
      {elementType === `ARGUMENT` && (
        <Field
          name={name}
          id={htmlId}
          component={InputComponent}
          format={null}
          parse={e => e}
        />
      )}
    </Flex>
  )
}
